import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"

export const isRowEmpty = (companyNewsTiles: CompanyNewsTile[]): boolean => {
  const hasContent = companyNewsTiles.filter((c) => c.config.type !== CompanyNewsTileType.Empty)
  return hasContent.length === 0
}

export const doesRowContainEmpty = (companyNewsTiles: CompanyNewsTile[]): boolean => {
  const emptyContent = companyNewsTiles.filter((c) => c.config.type === CompanyNewsTileType.Empty)
  return emptyContent.length > 0
}
